import { onMounted, onBeforeUnmount, computed, unref, watch } from 'vue';

/**
 * Запускает `requestAnimationFrame` и на каждый кадр выполняет колбэк, останавливается автоматически
 * @param cb - колбэк
 * @param {Ref<boolean> | boolean} pause - если true - то ставим на паузу
 */
export const useRafFps = (cb, pause = false, fps = 60) => {
  let id;
  let start = document.timeline.currentTime;

  const pauseLocal = computed(() => {
    return unref(pause);
  });

  const step = (timestamp) => {
    const dt = timestamp - start;
    start = timestamp;
    cb(dt);

    if (!pauseLocal.value) setTimeout(function () {
        id = requestAnimationFrame(step);
    }, 1000 / fps);
  }

  watch(pauseLocal, (val) => {
    if (!val) {
        start = document.timeline.currentTime;
        id = requestAnimationFrame(step);
    }
  });

  onMounted(() => {
    start = performance.now();
    id = requestAnimationFrame(step);
  });

  onBeforeUnmount(() => {
    cancelAnimationFrame(id);
  });
}
